import { Component, OnInit, Input, Output, EventEmitter, signal, computed } from "@angular/core";
import { OperateSidebarService } from "../operate-sidebar.service";
import { DateService } from "@root/shared/service/date.service";
import _ from "lodash";
import { NzMessageService } from "ng-zorro-antd/message";
import { TranslateService } from "@root/shared/service/translate.service";
import * as moment from "moment";
import { Parent, MultiHouseCalendarService } from "../../calendar/multi-house-calendar/multi-house-calendar.service";
@Component({
  selector: "host-inventory-panel",
  templateUrl: "./inventory-panel.component.html",
  styleUrls: ["./inventory-panel.component.scss"],
})
export class InventoryPanelComponent implements OnInit {
  @Input()
  set entity(entity: Parent) {
    if (entity) {
      this.selectedRoomTypes.set([
        {
          label: entity.p_title,
          value: entity.p_id,
        },
      ]);
    }
  }
  @Input() nights;
  @Input() dateRange: Array<string | Date> = [];
  @Output() success = new EventEmitter();

  selectedRoomTypes = signal<Option[]>([]);
  selectedRoomTypeIds = computed<number[]>(() => this.selectedRoomTypes()?.map((type) => type.value));

  nzFormat = this.dateService.getAngularFormat(["YMD"]);
  constructor(
    private operateSidebarService: OperateSidebarService,
    private houseCalendarService: MultiHouseCalendarService,
    private messageService: NzMessageService,
    private dateService: DateService,
    private t: TranslateService,
  ) {}

  ngOnInit() {}

  onSelectRoomTypes(types: Option[]) {
    this.selectedRoomTypes.set(types);
  }

  onRemoveType(id) {
    const list = this.selectedRoomTypes().filter((type) => type.value !== id);
    this.selectedRoomTypes.set(list);
  }

  private requestSyncInventory() {
    if (this.selectedRoomTypes().length === 0) {
      this.messageService.warning(this.t.t("warning.sidebar.house_type_required"));
      return;
    }

    const ids = this.selectedRoomTypeIds();
    const begin = moment(_.head(this.dateRange)).format("YYYY-MM-DD");
    const end = moment(_.last(this.dateRange)).format("YYYY-MM-DD");

    const params = {
      house_type_ids: JSON.stringify(ids),
      begin,
      end,
    };

    this.operateSidebarService.batchSetTypeInventory(params).subscribe((res) => {
      if (res?.error_code === 0) {
        this.refreshCalendar();
        this.success.emit();
      }
    });
  }

  onChangeDate(value) {
    const head = moment(_.head(value)).subtract(1, "d");
    const last = moment(_.last(value));

    this.nights = moment(last).diff(head, "days");
  }

  refreshCalendar() {
    this.houseCalendarService.calendarRefreshRaw$.next(null);
  }

  onClickCancel() {
    this.success.emit();
  }

  onClickSave() {
    console.log("onClickSave: in natvie element");
    this.requestSyncInventory();
  }
}
